import React, { Fragment } from 'react';
import { useId } from '@atlaskit/ds-lib/use-id';
import { MenuListItem } from '../menu-item/menu-list-item';
import { MenuSectionContext } from './menu-section-context';
/**
 * __MenuSection__
 *
 * A composable component for grouping menu items, along with a heading (`MenuSectionHeading`) and a divider (`Divider`).
 *
 * Usage example:
 * ```jsx
 * <MenuSection>
 *   <MenuSectionHeading>Section heading</MenuSectionHeading>
 *   <MenuList>
 *     <MenuItem>Item 1</MenuItem>
 *     <MenuItem>Item 2</MenuItem>
 *   </MenuList>
 *   <Divider />
 * </MenuSection>
 * ```
 */
export var MenuSection = function MenuSection(_ref) {
  var children = _ref.children,
    _ref$isMenuListItem = _ref.isMenuListItem,
    isMenuListItem = _ref$isMenuListItem === void 0 ? false : _ref$isMenuListItem;
  var id = useId();
  var Wrapper = isMenuListItem ? MenuListItem : Fragment;
  return /*#__PURE__*/React.createElement(MenuSectionContext.Provider, {
    value: id
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-labelledby": "".concat(id, "-heading")
  }, children)));
};